// removed by extract-text-webpack-plugin
module.exports = {"userMenuWrapper":"S2JOOT0gEwEvQiEv","userMenuContainer":"FYh6aMCJqBSiqj__"};


//////////////////
// WEBPACK FOOTER
// ./app/components/User/UserMenu/UserMenu.pcss
// module id = 510
// module chunks = 1